import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchSellersData, fetchFavouriteSellerData, fetchCategoriesData } from "../api/ApiService";
import { sortByDistance } from "../components/common/utils";

export const initialState = {
  loading: false,
  hasErrors: false,
  sellersStatus: "",
  sellers: [],
  buyItAgainSellers: [],
  favoriteSellers: [],
  favoriteBuyItAgainSellers: [],
  recommendedSellers: [],
  data: {},
  sellerDetails: {},
  categories: [],
  categoriesStatus: ""
};

export const sellerSlice = createSlice({
  name: "seller",
  initialState,
  reducers: {
    toggleFavorite(state, action) {
      const sellerId = action.payload;
      const existingSeller =
        state.sellers.find((s) => s._id === sellerId) ||
        state.buyItAgainSellers.find((s) => s._id === sellerId) ||
        state.recommendedSellers.find((s) => s._id === sellerId);

      if (!existingSeller) return;

      const newFavoriteStatus = !existingSeller.isFavorite;

      state.favoriteSellers = state.favoriteSellers.filter(
        (favSeller) => favSeller._id !== sellerId
      );

      if (newFavoriteStatus) {
        state.favoriteSellers = [
          ...state.favoriteSellers,
          { ...existingSeller, isFavorite: true }
        ];
      }

      const updateFavoriteStatus = (list) =>
        list.map((s) =>
          s._id === sellerId ? { ...s, isFavorite: newFavoriteStatus } : s
        );

      state.sellers = updateFavoriteStatus(state.sellers);
      state.buyItAgainSellers = updateFavoriteStatus(state.buyItAgainSellers);
      state.recommendedSellers = updateFavoriteStatus(state.recommendedSellers);
    },

    getSellerDetails(state, action) {
      state.sellerDetails = action?.payload?.sellerData;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSellers.pending, (state) => {
        state.loading = true;
        state.hasErrors = false;
        state.sellersStatus = "loading";
      })
      .addCase(fetchSellers.fulfilled, (state, action) => {
        const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
        const defaultLat = parseFloat(defaultAddress?.latitude);
        const defaultLon = parseFloat(defaultAddress?.longitude);
        state.sellers = sortByDistance(action?.payload?.sellers || [], defaultLat, defaultLon);
        state.buyItAgainSellers = sortByDistance(action?.payload?.buyItAgainSellers || [], defaultLat, defaultLon);
        state.favoriteSellers = sortByDistance(action?.payload?.favoriteSellers || [], defaultLat, defaultLon);
        state.recommendedSellers = sortByDistance(action?.payload?.recommendedSellers || [], defaultLat, defaultLon);
        state.favoriteBuyItAgainSellers = sortByDistance(action?.payload?.favoriteBuyItAgainSellers || [], defaultLat, defaultLon);
        state.data = action.payload;
        state.sellersStatus = "loaded";
        state.hasErrors = false;
      })
      .addCase(fetchSellers.rejected, (state) => {
        state.hasErrors = true;
        state.sellersStatus = "loaded";
      })
      .addCase(fetchCategories.pending, (state) => {
        state.categoriesStatus = "loading";
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.categoriesStatus = "loaded";
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state) => {
        state.categoriesStatus = "error";
      });
  },
});

export const fetchSellers = createAsyncThunk(
  "seller/fetchSellers",
  async (body) => {
    const data = await fetchSellersData(body);
    return data;
  }
);

export const favouriteSellers = createAsyncThunk(
  "seller/favoriteSellers",
  async (body) => {
    const data = await fetchFavouriteSellerData(body);
    return data;
  }
);
export const fetchCategories = createAsyncThunk(
  "seller/fetchCategories",
  async (body) => {
    const data = await fetchCategoriesData(body);
    return data;
  }
);

export const { toggleFavorite } = sellerSlice.actions;
export default sellerSlice.reducer;
